import React, { Component } from "react";
import GridDataView, { GRID_SIZE } from "../DataView/GridDataView";
import Strings from "@my-dld/assets/strings";
import { EnocMReqProps } from "./EnocMListView";
import { ENocMAction, ENocMApplication, ViewAction } from "../../enocapi/entities";
import { isEmptyStringOrNull } from "@eres/core/dist/StringUtils";
import {
	getEnocEligibility,
	getEnocOwnerAssociation,
	getEnocPropertyInfo,
	getEnocReqNo,
	getEnocReqStatus,
	getEnocReqStatusClass,
	getEnocSubmissionDate
} from "@my-dld/screens/MyDLD/MyRequest/EnocMollakRequests";
import { LocaleUtil } from "@eres/core";

interface State {
	searchKey?: string;
	page: number;
}

class EnocMGridView extends Component<EnocMReqProps, State> {
	constructor( props: EnocMReqProps ) {
		super( props );
		this.state = {
			page: 1,
		};
	}

	render() {
		const { items, onAction } = this.props;
		const { searchKey } = this.state;
		const filterData = this.getFilterData( searchKey );
		return <GridDataView
			items={ this.getPageData( filterData ) }
			onSearch={ this.onSearch }
			renderGridItem={ ( item: ENocMApplication ) => {
				return <RenderGridItem
					key={ item.id }
					item={ item }
					onAction={ onAction }
				/>;
			} }
			totalCount={ !isEmptyStringOrNull( searchKey ) ? filterData.length : items.length }
			onPageChange={ this.onPageChange }/>;
	}

	private getFilterData( sKey?: string ) {
		const { items } = this.props;
		if ( sKey ) {
			return items.filter( ( item: ENocMApplication ) => {
				const filterKeys: string[] = [];
				filterKeys.push( getEnocReqNo( item )! );
				filterKeys.push( getEnocReqStatus( item )! );
				filterKeys.push( getEnocPropertyInfo( item )! );
				filterKeys.push( getEnocOwnerAssociation( item )! );
				const fItem = filterKeys.find( ( fKey: string ) => fKey.toLocaleLowerCase().includes( sKey.toLocaleLowerCase() ) );
				return fItem != undefined;
			} );
		}
		return items;
	}

	private getPageData( filterData: ENocMApplication[] ) {
		const { page } = this.state;
		return filterData.slice( ( page - 1 ) * GRID_SIZE, page * GRID_SIZE );
	}

	private onSearch = ( sKey?: string ) => {
		this.setState( {
			searchKey: sKey,
			page: 1
		} );
	};

	private onPageChange = ( page: number ) => {
		this.setState( { page: page } );
	};
}

export default EnocMGridView;

function RenderGridItem( props: { item: ENocMApplication, onAction: ( action: ENocMAction, request: ENocMApplication ) => void } ) {
	const { item, onAction } = props;
	const isEligible = !!( item.eligibility && item.eligibility.nameEn && item.eligibility.nameEn !== "" );
	const cssClass = "btn-link ";
	return <div className="col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 property-card">
		<div className="card">
			<div className="card-body custom-body">
				<div className="detail-holder">
					<div className="custom-card-title">
						<div>
							<span>{ getEnocReqNo( item ) }</span>
							<span>{ Strings.request_ref }</span>
						</div>
						<div className={ `property-status ${ getEnocReqStatusClass( item ) }` }>
							{ getEnocReqStatus( item ) }
						</div>
					</div>
					<div className="row no-gutters property-card-detail col-item-3">
						<div className="col-12">
							<span>{ getEnocPropertyInfo( item ) }</span>
							<span>{ Strings.property_information }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-detail col-item-3">
						<div className="col-6">
							<span>{ getEnocSubmissionDate( item ) }</span>
							<span>{ Strings.submission_date }</span>
						</div>
						{
							isEligible &&
							<div className="col-6">
								<span>{ getEnocEligibility( item ) }</span>
								<span>{ Strings.eligibility_status }</span>
							</div>
						}
					</div>
					<div className="row no-gutters property-card-detail col-item-3">
						<div className="col-12">
							<span>{ getEnocOwnerAssociation( item ) }</span>
							<span>{ Strings.owners_association }</span>
						</div>
					</div>
					<div className="row no-gutters property-card-action">
						<div className="col-md-12">
							{
								item.actions && item.actions.length > 0 && item.actions?.map( ( action: ENocMAction, indexP: number ) => {
									return <>
										<button
											key={ "#tr" + indexP }
											onClick={ () => {
												onAction( action, item );
											} } className={ cssClass + action.color }>{ LocaleUtil.getLocalValue( action ) }</button>

									</>;
								} )
							}
							<button
								key={ "#tr_submit" }
								onClick={ () => {
									onAction( ViewAction, item );
								} } className={ cssClass + ViewAction.color }>{ LocaleUtil.getLocalValue( ViewAction ) }</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>;
}

/*
 <div className="row no-gutters property-card-action">
                        { statusId === RTRequestStatusId.PENDING && <div className="col-md-12">
                            <button className="btn-link" onClick={ () => {
                                onShowCancel(item);
                            } }>{ Strings.cancel }</button>
                        </div> }
                    </div>
 */
